import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PopupService {
  public afterClosePopupObject: Object;

  constructor() {}
}
